addEventListener("turbo:frame-load", ({ target }) => {
  if (!target.id.match(/request-\d+-status/)) return
  target.closest("tr.table-info").classList.remove("table-info")
})
